import { SET_CHERTO_EXPERIMENTS } from './actionConstants'
import type { AppAction } from './types/ActionTypes'

export function setChertoExperiment(experimentId: string, experiment: App.ChertoExperimentDetails, force?: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (!force && state.cherto.chertoExperiments[experimentId]?.triggered) {
      return
    }

    dispatch({
      type: SET_CHERTO_EXPERIMENTS,
      experiments: {
        [experimentId]: {
          ...experiment,
          triggered: !force ? true : experiment.triggered,
        },
      },
    })
  }
}
